import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconArrowForward } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { HotelCategory } from '../../../../../../components/HotelCategory/index.js';
import { Caption } from '../../../../../../components/UpliftAds/components/Banner/components/Tile/components/Caption.js';
import { Container } from '../../../../../../components/UpliftAds/components/Banner/components/Tile/components/Container.js';
import { Hotel } from '../../../../../../components/UpliftAds/components/Banner/components/Tile/components/Hotel.js';
import { Link } from '../../../../../../components/UpliftAds/components/Banner/components/Tile/components/Link.js';
import { LabelMedium, Postcard, Stack } from '../../../../../../primitives/index.js';
export const Tile = ({
  hotel,
  title,
  subtitle,
  image,
  category
}) => {
  const {
    t
  } = useTranslation('upliftAds');
  return _jsxs(Stack, {
    spacing: "small",
    children: [_jsx(LabelMedium, {
      color: "contentSecondary",
      children: t('label')
    }), _jsxs(Container, {
      children: [_jsxs(Hotel, {
        children: [hotel, _jsx(HotelCategory, {
          value: category,
          type: "unverified",
          size: "small"
        })]
      }), _jsx(Postcard, {
        captionOverlay: "custom",
        image: image,
        caption: _jsx(Caption, {
          title: title,
          subtitle: subtitle
        }),
        fit: true
      }), _jsxs(Link, {
        color: "contentInversePrimary",
        children: [t('button'), _jsx(IconArrowForward, {
          color: "contentInversePrimary"
        })]
      })]
    })]
  });
};